const locale = {
  // Page title and description
  CHANGELOG: 'Changelog',
  CHANGELOGDESCRIPTION: 'Version history and release notes',

  // Section labels
  SECTION_NEW: '✨ New',
  SECTION_CHANGED: '🔧 Changed / Improved',
  SECTION_FIXED: '🐛 Fixed',
  SECTION_BREAKING: '💥 Breaking',
  SECTION_DEPRECATED: '⚠️ Deprecated',
  SECTION_SECURITY: '🔒 Security',
  SECTION_PERFORMANCE: '📈 Performance',
  SECTION_INFRASTRUCTURE: '🧱 Infrastructure',
  SECTION_DOCS: '📚 Docs',

  // Product labels
  PRODUCT_BUSINESSSUITE: 'Business Suite',
  PRODUCT_TIMELITE: 'TimeLite',
  PRODUCT_EXKURSIO: 'Exkursio',

  // Search
  SEARCH: 'Search',
};

export default locale;

